export default __webpack_public_path__ + "5c6e178d0c91aa21cf8b0f4302add9ac.png";